import React from 'react'
import moment from 'moment/moment'
import {Link} from 'react-router-dom'

function AttachTagItemRow(props) {
    const {item, setType, setBrand, setUser} = props
    const {
        barcode,
        type,
        size,
        mark_tagged = {},
        batch,
        batch_id,
        brand_name,
        brand,
        order3d_at,
        order3d,
        pos: itemIndex,
    } = item

    const { barcodeNumber} = {...barcode}
    const barcodeStr = barcodeNumber + '_' + itemIndex
    const is3D = order3d && order3d_at && barcodeStr && itemIndex

    
    const onClickBrandItemRow = (value) => {
        setBrand(value)
    }

    const onClickTypeItemRow = (value) => {
        setType(value)
    }

    const onSetUserItemRow = (user) => () => {
        setUser(user)
    }

    const brandName = brand ? brand.name : brand_name
    const vBatch = batch || batch_id

    return (
        <tr className='AttachTagItemTr'>
            <td className='AttachTagItemBarcode'>
                {is3D &&
                <Link
                    to={`/order-item?template=${barcodeStr}`}
                    target="_blank">
                    #{barcodeStr}
                </Link>
                }
                {
                    !is3D && `#${barcodeStr}`
                }
            </td>
            <td className="ProductType AttachTagItemType">
                {
                    !!type &&
                    <span className="mr-2" onClick={() => onClickTypeItemRow([type])}>{type}</span>
                }

                {
                    !!brandName &&
                    <div className="Brand">
                        <span className="mr-2" onClick={() => onClickBrandItemRow([brandName])}>{brandName}</span>
                    </div>
                }
            </td>
            <td className="AttachTagItemSize">{size || '-'}</td>
            <td className="AttachTagItemBatch">
                {
                    (vBatch &&
                        <Link to={`/batches/${vBatch._id || vBatch.id}`}>
                            {vBatch.name}
                        </Link>
                    ) || '-'
                }
            </td>
            <td className="AttachTagItemDate">{moment(mark_tagged.date).format('HH:mm DD/MM/YYYY') || '-'}</td>
            <td className="AttachTagItemUser">
                {
                    mark_tagged.user &&
                    <span className="mr-2" onClick={onSetUserItemRow(mark_tagged.user)}>{mark_tagged.user}</span>
                }
                
                {
                    !mark_tagged.user && '-'
                }
            </td>
        </tr>
    )
}

export default AttachTagItemRow
